
        async function fetchGoogleReviews() {
            const apiKey = "AIzaSyBUdbeuiE69rgF_INFnABTVgWpBiniXAbE";  // Google API anahtarını buraya ekle
            const placeId = "ChIJq6reNPO6yhQRz0UwvWOutdE";  // İşletme Place ID'sini buraya ekle
            const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=reviews&key=${apiKey}`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (data.result && data.result.reviews) {
                    const reviews = data.result.reviews;
                    let reviewHTML = '';

                    reviews.forEach(review => {
                        reviewHTML += `
                            <div class="review">
                                <p><strong>${review.author_name}</strong> - ⭐ ${review.rating}/5</p>
                                <p>${review.text}</p>
                            </div>
                        `;
                    });

                    document.getElementById('reviews').innerHTML = reviewHTML;
                } else {
                    document.getElementById('reviews').innerHTML = "<p>Henüz yorum bulunmamaktadır.</p>";
                }
            } catch (error) {
                console.error("Google yorumlarını çekerken hata oluştu:", error);
            }
        }

        fetchGoogleReviews();

